<template>
  <section>
    <header>
      <h2>{{ title }}</h2>
      <span class="more" @click="gotoPage">全部</span>
    </header>
    <course-list :courses="courses"></course-list>
  </section>
</template>

<script>
import CourseList from './CourseList'

export default {
  name: 'CourseListWrapper',
  components: {
    CourseList
  },
  props: {
    title: {
      type: String,
      required: true
    },
    to: {
      type: String,
      required: true
    },
    miniPath: {
      type: String,
      default: ''
    },
    courses: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
    }
  },
  methods: {
    gotoPage () {
      console.log('gotoPage')
      console.log(this.$route.query.platform)
      if (this.$route.query.platform === 'mini') {
        wx.miniProgram.navigateTo({ url: this.miniPath })
      } else {
        this.$router.push({ path: this.to })
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
section
  background-color #fff
  padding 0 15px
  margin-top 10px
  header
    height 32px
    padding 6px 0
    box-sizing border-box
    line-height 20px
    border-bottom 1px solid #DDDDDD
    h2
      float left
      color #363636
      padding-left 8px
      font-size 14px
      border-left 2px solid #8D5AD8
    .more
      float right
      color #7B7B7B
      font-size 12px
      padding-right 12px
      background url("~@/assets/images/icons/icon-arrow-right.png") no-repeat right 2px
      background-size 8px 14px
</style>
